import { parseISO } from "date-fns";

import { useTablePagination } from "components/Table/hooks";

const getTemplateAccessList = ({ page, pageSize = 10 }) => {
  const query = `query getTemplateAccessList {
        templateAccessList(first: ${pageSize}, offset: ${page * pageSize}) {
          edges {
            node {
              id
              accessAllowed {
                name
              }
              requestedByName
              requestedByEmail
              status
              createdAt
            }
          }
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }`;

  const resolver = ({ data: { templateAccessList } }) => {
    return {
      accessList: templateAccessList.edges.map(({ node }) => {
        return {
          ...node,
          createdAt: parseISO(node.createdAt),
        };
      }),
      totalCount: templateAccessList.totalCount,
    };
  };

  return { query, resolver };
};

const useAccessListTable = () => {
  const { pageControl, updatePageControl, reloadData, loading, data } =
    useTablePagination(getTemplateAccessList);

  return {
    pageControl: pageControl,
    updatePageControl: updatePageControl,
    loading: loading,
    totalCount: data?.totalCount || 0,
    accessList: data?.accessList || [],
    reloadData: reloadData,
  };
};

export default useAccessListTable;
